import { createActionTypes } from 'redux/utils/actionUtils';

export const type = 'PAGEVIEW_EVENT';

const actionTypes = [
  type + '_CREATE',
  type + '_CREATED',
  type + '_DELETED',
  type + '_FETCHING_EVENTS',
  type + '_FETCH_EVENTS_SUCCESS',
  type + '_UPDATE_NEW',
  type + '_UPDATE',
  type + '_UPDATED'
];

export default createActionTypes(actionTypes);



/** WEBPACK FOOTER **
 ** ./src/redux/modules/pageview/pageviewActionType.js
 **/